<sim-list-item
	(click)="onClick($event)"
	[indicator]="userIcon() ?? userInitials()"
	[primaryLabel]="user().fullname"
	[secondaryLabelIcon]="secondaryLabelIcon"
	[secondaryLabel]="secondaryLabel"
	[selected]="selected"
>
	<ng-container actions>
		<ng-content select="[actions]" />
		@if (deletable) {
			<button mat-icon-button color="warn" appStopPropagation (click)="deleteClicked()">
				<mat-icon fontSet="fas" fontIcon="fa-times" inline />
			</button>
		}
	</ng-container>
</sim-list-item>
